// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"PDPA_wrapper__1WlBv","content":"PDPA_content__3fzcO","link":"PDPA_link__2Bkf-","button":"PDPA_button__T9JF5"};